import Ajax from 'js/utils/ajax/ajax';

export const getBulkOrders = () => Ajax.get('/importorders/v1');

export const handleBulkOrder = (importFileId, action) =>
  Ajax.post(`/importorders/v1/${importFileId}/actions/${action}`, importFileId, action);

export const createBulkOrder = (shopId, transportSolutionId, formData) =>
  Ajax.postMultiPart(`/importorders/v1/${shopId}/${transportSolutionId}`, formData);
